// removed by extract-text-webpack-plugin
module.exports = {"img-loading":"img-loading"};


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/Loading/style.less
// module id = 1146
// module chunks = 418